import { render, staticRenderFns } from "./ClientesList.vue?vue&type=template&id=06a6607a&"
import script from "./ClientesList.vue?vue&type=script&lang=js&"
export * from "./ClientesList.vue?vue&type=script&lang=js&"
import style0 from "./ClientesList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports